import { t } from '@lingui/core/macro';

import { useOpportunitiesList } from '@/api/opportunity';
import { useInstantSearchState } from '@/components/InstantSearch';
import { getSolQueryParamsNewFromQueryState } from '@/components/InstantSearch/util/search-util';
import { usePageFilterContext } from '@/components/page';
import { Panel } from '@/components/panels';

import { OpportunitiesOverviewTable } from './OpportunitiesOverviewTable';

const OpportunitiesOverviewTableContainer = () => {
  const {
    pageFilters: { startDate, endDate, audience },
  } = usePageFilterContext();
  const { queryState } = useInstantSearchState();

  const { opportunityOverview, totalResults, isLoading, error } = useOpportunitiesList(
    getSolQueryParamsNewFromQueryState(queryState),
    startDate,
    endDate,
    audience,
  );

  return (
    <Panel title={t`Opportunities`} isFullHeight>
      <OpportunitiesOverviewTable
        data={opportunityOverview}
        totalResults={totalResults}
        isLoading={isLoading}
        error={error}
      />
    </Panel>
  );
};

export default OpportunitiesOverviewTableContainer;
